import { connect, mapReadPretty, mapProps } from "@formily/react";
import { TextField as TextFieldBase } from "../base/TextField";
import { isField } from "@formily/core";

export const TextField = connect(
  TextFieldBase,
  mapProps((props, field) => {
    if (!isField(field)) return props;

    return {
      ...props,
      label: field.title,
      description: field.description,
      errorMessage: field.selfErrors[0],
      isDisabled: field.disabled,
      onChange: (value) => {
        void field.onInput(value);
      },
    };
  }),
  mapReadPretty((props) => {
    return `${props.value}`;
  }),
);
